export const Environment = {
  production: true,
  local: 'http://127.0.0.1:5745/github/engineering/sena/a7399293e62d/',
  backend: 'https://xs.engcode.dev/github/engineering/sena/a7399293e62d/',
  template: 'https://smart.datacompute.org/version.4.5.1/html-full/dist',
};
